import { jwtDecode } from "jwt-decode";
import { LoginQuery } from "../services/LoginService";
import Alerts from "../components/common/Alerts/Alerts";
import { setUserDetails } from "../Redux/Slice/userSlice";
import { loginActionService } from "../services/LoginActionService";

export const USER_TYPE = {
  CUSTOMER: "customer",
  SELLER: "seller",
};

export const handleLogin = async (graphqlService, email, password, callbacks) => {
  const { 
    setRequetStart, 
    setAuth, 
    setSignIn = () => {}, 
    navigate,
    dispatch = null,
    redirectPath = null,
    clearRedirectPath = null
  } = callbacks;

  setRequetStart(true);

  try {
    const response = await LoginQuery(graphqlService, { email, password });
    
    if (response.loginUser?.access_token) {
      const accessToken = response.loginUser.access_token;
      const decodedToken = jwtDecode(accessToken);
      const userDetails = {
        accessToken,
        roleType: response.loginUser.roleType,
        expireAt: decodedToken.exp,
        // Add other user details as needed
        user: response.loginUser,
        personalEmail: response.loginUser.personalEmail,
        firstName: response.loginUser.firstName,
        lastName: response.loginUser.lastName,
        location: response.loginUser.location,
        abn: response.loginUser.abn,
        businessName: response.loginUser.businessName,
        companyName: response.loginUser.companyName,
        profilePicture: response.loginUser.profilePicture,
        // personalEmail: response.loginUser.personalEmail,
        startDate: response.loginUser.startDate,
        serviceCategory: response.loginUser.serviceCategory,
        userPlan: response.loginUser.userPlan,
      };

      // Save to localStorage
      localStorage.setItem("LoginSession", JSON.stringify(userDetails));
      
      // Update auth context
      setAuth(userDetails);
      
      // Update Redux state if dispatch is provided
      if (dispatch) {
        dispatch(setUserDetails(userDetails));
      }

      // Check if there's a pending scenario that should prevent default redirect
      const hasPendingScenario = loginActionService.getStoredScenario() !== null;
      console.log('hasPendingScenario:', hasPendingScenario);
      console.log('stored scenario:', loginActionService.getStoredScenario());

      // Redirect logic - prioritize pending scenarios and stored redirect path over default redirects
      if (hasPendingScenario) {
        // If there's a pending scenario, don't redirect - let the component handle it
        // The component's onLoginSuccess callback will handle the scenario
        console.log('Pending scenario detected, not redirecting');
        // Don't close login modal here - let the component handle it
      } else {
        // Close login modal only if no pending scenario
        setSignIn(false);
        
        if (redirectPath) {
          console.log('Redirecting to:', redirectPath);
          navigate(redirectPath, { replace: true });
          if (clearRedirectPath && dispatch) dispatch(clearRedirectPath());
        } else if (response.loginUser.roleType === USER_TYPE.SELLER) {
          console.log('Redirecting to dashboard');
          navigate("/business-dashboard/dashboard", { replace: true });
        } else {
          console.log('Redirecting to Services');
          navigate("/Services", { replace: true });
        }
      }

    //   Alerts.success("Login successful!");
      return true;
    } else {
      Alerts.error(response.login.message || "Login failed");
      return false;
    }
  } catch (error) {
    Alerts.error(error.message || "Login failed");
    return false;
  } finally {
    setRequetStart(false);
  }
}; 